import { ReactComponent as WhiteLogoSvg } from 'images/Savant_white_logo.svg'
import routes from 'app/routes'
import {
  StyledHeaderLogoWrapper,
  StyledHeaderLogo,
  StyledHeaderLogoSubTitle,
} from './styles'
import { useAppSelector } from 'app/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'

function HeaderLogo() {
  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  return (
    <StyledHeaderLogo to={routes.homesJobs(currentRootId)}>
      <StyledHeaderLogoWrapper>
        <WhiteLogoSvg></WhiteLogoSvg>
      </StyledHeaderLogoWrapper>
      <StyledHeaderLogoSubTitle>Central Management</StyledHeaderLogoSubTitle>
    </StyledHeaderLogo>
  )
}

export default HeaderLogo
